import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import DOMPurify from 'dompurify';
import { renderLexicalRichText } from '../../../../utility/lexical-viewer';
import { shortenContent } from '../../../../utility/format-content';
import apiInstance from '../../../../utility/apiInstance';

const FeaturedInstitutions = () => {

    const route = all_routes

    type CountryOption = {
        name: string,
        value: string
    }

    type Institution = {
        id: string,
        country: string,
        schoolName: string,
        location: string,
        about: any
    };

    type InstitutionsByCountry = {
        [country: string]: Institution[];
    }

    const [institutionByCountry, setInstitutionByCountry] = useState<InstitutionsByCountry>({});
    const [selectedCountry, setSelectedCountry] = useState<string | null>('United Kingdom');

    const topCountries: CountryOption[] = [
        {
            name: 'Australia',
            value: 'AU'
        },
        {
            name: 'Canada',
            value: 'CA'
        },
        {
            name: 'Germany',
            value: 'DE'
        },
        {
            name: 'Ireland',
            value: 'IE'
        },
        {
            name: 'United States',
            value: 'US'
        },
        {
            name: 'United Kingdom',
            value: 'GB'
        }
    ];

    const fetchInstitutions = async (): Promise<InstitutionsByCountry> => {

        try {
            const requests = topCountries.map(({ name, value }) =>
                apiInstance.get('/api/institutions', {
                    params: {
                        limit: 3,
                        'where[country][equals]': value,
                    },
                }).then((res) => ({
                    country: name,
                    institutions: res.data.docs as Institution[],
                }))
            );

            const results = await Promise.all(requests);

            const data: InstitutionsByCountry = {};
            results.forEach(({ country, institutions }) => {
                data[country] = institutions;
            });

            return data;

        } catch (error) {
            console.error('Error fetching featured institutions:', error);
            return {};
        }
    };

    useEffect(() => { fetchInstitutions().then(setInstitutionByCountry) }, [])

    return (
        <>
            {/* Featured Courses Five*/}
            <section className="featured-section-five">
                <div className="container">
                    <div
                        className="section-header section-header-six text-center"
                        data-aos="fade-down"
                    >
                        <h2>Trusted Partners</h2>
                        <p>
                            Trusted by over 1,500 educational institutions globally, including universities, colleges and schools.
                        </p>
                    </div>
                    <div className="top-countries">
                        <div onClick={() => setSelectedCountry('Australia')} className={(selectedCountry === 'Australia' ? 'active' : '')}>Australia</div>
                        <div onClick={() => setSelectedCountry('Canada')} className={(selectedCountry === 'Canada' ? 'active' : '')}>Canada</div>
                        <div onClick={() => setSelectedCountry('Germany')} className={(selectedCountry === 'Germany' ? 'active' : '')}>Germany</div>
                        <div onClick={() => setSelectedCountry('Ireland')} className={(selectedCountry === 'Ireland' ? 'active' : '')}>Ireland</div>
                        <div onClick={() => setSelectedCountry('United States')} className={(selectedCountry === 'United States' ? 'active' : '')}>United States</div>
                        <div onClick={() => setSelectedCountry('United Kingdom')} className={(selectedCountry === 'United Kingdom' ? 'active' : '')}>United Kingdom</div>
                    </div>
                    <div className="row">
                        <div className="featured-courses-five-tab">
                            <div className="tab-content">
                                <div className="ux-design-five">
                                    <div className="row">

                                        {
                                            Object.entries(institutionByCountry).map(([country, institutions]) => (
                                                (selectedCountry === country &&
                                                    <div className="row" key={country}>
                                                        {institutions.map((item) => (
                                                            <div className="col-lg-4 col-md-6 d-flex">
                                                                <div
                                                                    className="course-item course-item-three mx-0 flex-fill aos"
                                                                    data-aos="fade-up"
                                                                >
                                                                    <div className="course-img">
                                                                        <ImageWithBasePath
                                                                            className="img-fluid"
                                                                            alt="Img"
                                                                            src="assets/img/course/course-40.jpg"
                                                                        />
                                                                    </div>
                                                                    <div className="course-content">
                                                                        <div className="course-user">
                                                                            <div className="course-user-img">
                                                                                <ImageWithBasePath
                                                                                        src="assets/img/avatar/avatar-21.jpg"
                                                                                        alt="Img"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                <div className="course-name">
                                                                                    <h4>
                                                                                        <Link
                                                                                            key={item.id}
                                                                                            to={route.institutionDetails.replace(":id", item.id)}
                                                                                            className="hover:underline text-blue-600"
                                                                                        >
                                                                                            {item.schoolName}
                                                                                        </Link>
                                                                                    </h4>
                                                                                    <p>{item.location}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(shortenContent(renderLexicalRichText(item.about))) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="text-center">
                        <Link
                            to={route.courseGrid}
                            className="btn btn-xl btn-primary mt-2"
                            data-aos="fade-up"
                        >
                            See More Courses
                        </Link>
                    </div> */}
                </div>
            </section>
            {/* /Featured Courses Five*/}
        </>

    )
}

export default FeaturedInstitutions
